// ts-nocheck

import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {_printDate, _printShortFullDate, _printSmallestFullDate, _printNumber} from '../../helpers/helpers.js'
import CveTitle from '../../components/cveTitle.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import SectionHeader from '../../components/sectionHeader.js'
import {DomainTechnology, CategoryData} from '../../components/domainTechnologies.js'
import VersionRef from '../../components/versionRef.js' 
import { HashLink } from 'react-router-hash-link';
import TechnologyVersionWithScore from '../../components/technologyVersionWithScore.js' 

import {RtMonitoringChange, RtUICVE, RtScanHistoryEntry, RtUITechnology, RtDomainInfo, RtMonitoringWebsiteDetailPageResult} from '../../../../server/routes/monitoring.js'

const Events = {
	techAdded: 'techAdded',
	techDropped: 'techDropped',
	techUpgraded: 'techUpgraded',
	cveAdded: 'cveAdded',
	cveDropped:'cveDropped'
} as const

type EventType = typeof Events[keyof typeof Events]

// interface Scan {
// 	Date: string;
// 	Success: boolean;
// 	Error?: string;
// }
type Scan = RtScanHistoryEntry;

// interface DomainInfo {
// 	Redirect?: string;
// }

// interface Technology {
// 	Technology: string;
// 	TechnologyURL: string;
// 	TechnologyIcon: string;
// 	Version?: string;
// 	Bucket?: number;
// 	PercentNewerVersion?: number;
// 	Category: string;
// 	CategoryTechnologyCount?: number;
// 	FirstDetected?: string;
// 	LastDetected?: string;
// }

// interface CVE {
// 	CVEId: string;
// 	Technology: string;
// 	TechnologyURL: string;
// 	TechnologyIcon: string;
// 	Version: string;
// 	Bucket: number;
// 	PercentNewerVersion: number;
// 	TechnologyVersion: string;
// 	UsedSince: string;
// 	LastSeen: string;
// }

interface Event {
	Technology: string;
	TechnologyURL: string;
	TechnologyIcon: string;
	Version: string;
	Bucket: number;
	PercentNewerVersion: number;
	Event: EventType;
	CVEs?: string[];
	VersionFrom?: string;
	VersionTo?: string;
}

// interface Change {
// 	Date: string;
// 	CVEChanges?: {
// 		Added: CVE[];
// 		Dropped: CVE[];
// 	};
// 	TechnologyChanges?: {
// 		Added: Technology[];
// 		Dropped: Technology[];
// 		ChangedVersions: Array<Technology & { VersionFrom: string; VersionTo: string }>;
// 	};
// }
type Change = RtMonitoringChange;

// interface MonitoringOptions {
// 	MonitorTechnologies: boolean;
// 	MonitorSecurity: boolean;
// }

// interface MonitoredWebsite {
// 	Website: string;
// 	LastScan?: Scan;
// 	Options: MonitoringOptions;
// 	ScanHistory?: Scan[];
// 	Changes?: Change[];
// 	Technologies?: Technology[];
// 	NewTechnologies?: Technology[];
// 	CVEs?: CVE[];
// 	DomainInfo?: DomainInfo;
// }

// interface MonitoringWebsitePageData {
// 	MonitoredWebsite?: MonitoredWebsite;
// 	SampleData?: boolean;
// 	CanonicalURL?: string;
// }

type TechnologyCategory = CategoryData;
// interface TechnologyCategory {
// 	Category: string; 
// 	CategoryTechnologyCount: number | null; 
// 	Technology: RtUITechnology[]
// }

interface MonitoringWebsiteProps {
	server: string;
	pageData: unknown;
}

export default function MonitoringWebsite({pageData}: MonitoringWebsiteProps) {
	
	const [data, setData] = useState(pageData as RtMonitoringWebsiteDetailPageResult);

	if (!data.MonitoredWebsite) return (<></>);

	if (!data.MonitoredWebsite.LastScan) {
		return (
		<>
			<MonitoringHeader props={data}/>			
			<br/>
			<br/>
			<p>
			<b>There is currently no monitoring data available for this website.</b>
			<br/><br/>
			If you recently added this website to the monitoring list, the system may need a few minutes to complete its initial scan. 
			<br/><br/>
			Please refresh the page after a few minutes.
			</p>
		</>);
	}

	return (
	<>            
		<section className="section section-sm">
        	<div className="container">	
			<MonitoringHeader props={data}/>			
			<br/>
			<br/>
			<MonitoringStats props={data}/>
			<br/>
			<br/>
			<DomainInfo domainInfo={data.MonitoredWebsite.DomainInfo} />
			<MonitoringReports props={data}/>			
			
			<MonitoringCVEList props={data}/>
			<br/>			

			<EventHistory props={data}/>		
			<br/>
			<MonitoringScanHistory props={data}/>
			<br/>			
			<MonitoringTechList props={data}/>
			<br/>
			</div>	
		</section>
	</>
	)
}

interface ComponentProps {
	props: RtMonitoringWebsiteDetailPageResult;
}

interface DomainInfoProps {
	domainInfo?: RtDomainInfo;
}

function MonitoringHeader({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);

	if (!!props.SampleData) return (
		<>
		<h2>Sample Domain</h2>
		<strong>Website Technology & Security Monitoring Report</strong>
		<p>
		The website name has been withheld for confidentiality. All technology stack and change history data reflect the state of the site accurately at the time of monitoring.
		</p>
		</>);

	return (
		<> 
			<h2>{props.MonitoredWebsite.Website}</h2>
			Website technology and security profile and timeline
		</>
	)

}

function MonitoringStats({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);

	return (
		<> 
		<table className="word-break table-custom table-custom-striped table-custom-primary">
			<tbody>
				<tr >
					<td width='25%'>Technology Changes</td>
					<td align='left'>
						{props.MonitoredWebsite.Options.MonitorTechnologies ? 'Monitored' : '-'}
					</td>
				</tr>						
				<tr>
					<td width='25%'>Security Changes</td>
					<td align='left'>
						{props.MonitoredWebsite.Options.MonitorSecurity ? 'Monitored' : '-'}
					</td>
				</tr>
				<tr>
					<td width='25%'>Latest Scan</td>
					<td align='left'>
						{props.MonitoredWebsite.LastScan ? _printShortFullDate(props.MonitoredWebsite.LastScan.Date) : '-'}
					</td>
				</tr>
				<tr>
					<td width='25%'>Latest Scan Result</td>
					<td align='left'>
						{props.MonitoredWebsite.LastScan ? (props.MonitoredWebsite.LastScan.Success ? 'Website Scanned' : props.MonitoredWebsite.LastScan.Error) : '-'}
					</td>
				</tr>
			</tbody>
		</table>
		</>
	)
}

function DomainInfo({domainInfo}: DomainInfoProps) {

	if (!domainInfo) return null;
	if (!domainInfo.Redirect) return null;

	return (
		<div className="row row-50">
			<div className="col-12">
				<p style={{color: 'red'}}>
				Website redirects to <b>{domainInfo.Redirect}</b>
				</p>
			</div>
		</div>
	)
}

function MonitoringReports({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);

	return (
	<> 		
		<div>
			<h4>Available Reports</h4>
			<ul>
				<li>
					<HashLink  smooth 
						to="#security"
						className="link-hover" 
						title={'List of security issues currently detected on the website'}
					>
						Security Issues
					</HashLink>
				</li> 	
				<li>
					<HashLink  smooth 
						to="#eventhistory"
						className="link-hover" 
						title={'Timeline of security events and technological changes'}
					>
						Change History
					</HashLink>
				</li>     				
				<li>
					<HashLink  smooth 
						to="#recentscans"
						className="link-hover" 
						title={'List of recent scans'}
					>
						Scan History
					</HashLink>
				</li>
  			
				<li>
					<HashLink  smooth 
						to="#tech"
						className="link-hover" 
						title={'Technologies currently used on website'}
					>
						Technologies
					</HashLink>
				</li> 	
			</ul>      
		</div>
	</>
	)
}

function compareByDate(a: Scan | Change, b: Scan | Change): number {
	// workaround null element
    if (a === null || b === null)
        return a < b ? -1 : 1;

    if (a.Date < b.Date)
        return 1;
    if (a.Date > b.Date)
        return -1;
    return 0;
}

function MonitoringScanHistory({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);
	if (!props.MonitoredWebsite.ScanHistory) return (<></>);

	const header = {
		Title: 'Scan History',
		Subtitle: `List of latest scans`
	};

	let history = props.MonitoredWebsite.ScanHistory.sort( 
		(a,b) => compareByDate(a , b));

	history = history.slice(0, 4);

	return (
		<> 
		<SectionHeader header={header} link={props.CanonicalURL} anchor='recentscans'/>
		<div className="table-outer table-rounded table-respoSnsive-lg">
			<table className="table-custom table-custom-striped table-custom-primary  ">
				<thead>
				<tr>
					<th style={{width: '20%'}}>Date</th>
					<th style={{width: '20%'}}>Scan</th> 
					<th style={{width: '60%'}}>Description</th> 
				</tr>
				</thead>
				<tbody>
				{
					history.map((scan, indexKey) => {
						return (
							<ScanRow scan={scan} key={indexKey}/>
						)
					})
				}	
				</tbody>
			</table>
		</div>		

		</>
	)

}

function EventHistory({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);
	if (!props.MonitoredWebsite.Changes) return (<></>);
//	if (!props.MonitoredWebsite.Changes || !props.MonitoredWebsite.Changes.length) return (<></>);

	const header = {
		Title: 'Change History',
		Subtitle: `Timeline of security events and technological changes`
	};

	return (
		<>
		<div className="row row-50">
		<div className="col-12">
			<SectionHeader header={header} link={props.CanonicalURL} anchor='eventhistory'/>
			<EventHistoryTable props={props} />	
		</div>
		</div>
		</>
		)
}


function EventHistoryTable({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);
	if (!props.MonitoredWebsite.Changes) return (<></>);
	if (!props.MonitoredWebsite.Changes.length) return (<p>The monitoring service has not detected any changes since initial scan.</p>);

	let changes = props.MonitoredWebsite.Changes.sort( 
		(a,b) => compareByDate(a , b));

	// CVE, descr, tech, version

	return (
	<> 
		<div className="table-outer table-rounded table-respoSnsive-lg">
		<table className="table-custom table-custom-striped table-custom-primary  ">
			<thead>
			<tr>
				<th style={{width: '15%'}}>Date</th>
				<th style={{width: '50%'}}>Event</th>				
				<th style={{width: '35%'}}>Technology</th>
			</tr>
			</thead>
			<tbody>
			{
				changes.map((change, indexKey) => {
					return (
						<ChangeRows change={change}  key={indexKey}/>
					);
				})
			}	
			</tbody>
		</table>
		</div>		
	</>
	)

}

// function mergeByCategory(arr: Technology[]): Array<{Category: string; CategoryTechnologyCount: number | null; Technology: Technology[]}> {
//     return arr.reduce((acc, obj) => {
//       // Check if the category already exists in the accumulator
//       let category = acc.find(item => item.Category === obj.Category);
  
//       if (category) {
//         // If category exists, push the technology to the list of technologies
//         category.Technology.push(obj);
//       } else {
//         // If category does not exist, create a new entry
//         acc.push({
//           Category: obj.Category,
//           CategoryTechnologyCount: obj.CategoryTechnologyCount,
//           Technology: [obj]
//         });
//       }
  
//       return acc;
//     }, []);
// }

function returnUnmerged(arr: RtUITechnology[]): TechnologyCategory[] {
    return arr.map(obj => {
		const outCategoryData: TechnologyCategory = {
			CategoryTechnologyCount: undefined,
			Technology: obj
		}
		return outCategoryData;
    });
}

function MonitoringTechList({props}: ComponentProps) {
	if (!props.MonitoredWebsite) return (<></>);
	if (!props.MonitoredWebsite.Options.MonitorTechnologies) return (<></>);
	if (!props.MonitoredWebsite.Technologies) return (<></>);

	let tech = null;

	if (props.MonitoredWebsite.Technologies !== null) {	
		tech = props.MonitoredWebsite.Technologies.sort( 
			(a,b) => compareTechByCategory(a , b ));
	}	

    let catList: Array<TechnologyCategory> | null = null;

	// if (props.MonitoredWebsite.NewTechnologies) {
	// 	catList = returnUnmerged(props.MonitoredWebsite.NewTechnologies);
	// } else {
	{
		if (props.MonitoredWebsite.Technologies) {
			catList = returnUnmerged(props.MonitoredWebsite.Technologies);
		}
	}
    if (catList) {
        catList = catList.sort( (a,b) => compareTechByCategory(a.Technology, b.Technology));
    }

	const header = {
		Title: 'Technologies',
		Subtitle: `Technologies currently used on website`
	};

	return (
		<> 	
		<div className="row row-50">
			<div className="col-12">
				<SectionHeader header={header} link={props.CanonicalURL} anchor='tech'/>
				<div className="table-outer table-rounded table-responsive-lg">
					<table className="table-custom table-custom-striped table-custom-primary  ">
						<thead>
							<tr>
								<th style={{width: '25%'}}>Technology Type</th>								
								<th style={{width: '45%'}}>Technology</th>
								<th style={{width: '15%'}}>First detected</th>
								<th style={{width: '15%'}}>Last detected</th>   
							</tr>
						</thead>
						<tbody>
							{
								catList?.map((cat, indexKey) =>
									<DomainTechnology cat={cat} dayFormat={true} tooltip = '1' key={indexKey}/>
								)
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
		</>
	)

}
function compareTechByCategory<T>(a: {Category: string}, b: {Category: string}): number {
	// workaround null element
    if (a === null || b === null)
        return a < b ? -1 : 1;

    if (a.Category < b.Category)
        return -1;
    if (a.Category > b.Category)
        return 1;
    return 0;
}

function MonitoringCVEList({props}: ComponentProps) {
	const header = {
		Title: 'Security Issues',
		Subtitle: `List of security issues currently detected on the website`
	};

	if (!props.MonitoredWebsite) return (<></>);
	if (!props.MonitoredWebsite.Options.MonitorSecurity) return (<></>);
	if (!props.MonitoredWebsite.CVEs || !props.MonitoredWebsite.CVEs.length) return (
		<>
		<div className="row row-50">
		<div className="col-12">
			<SectionHeader header={header} link={props.CanonicalURL} anchor='security'/>
			<p>No security issues were found on this website.</p>
		</div>		
		</div>
		</>);

	// flatten
	let techMap = new Map<string, {CVEs: RtUICVE[]}>;
	let techList: Array<{Technology: string; Bucket: number; PercentNewerVersion: number; CVEs: RtUICVE[]}> = [];

	// Technology
	props.MonitoredWebsite.CVEs.map((cve) => {
		if (techMap.has(cve.Technology)) {
			let e = techMap.get(cve.Technology);
			if (e) {
				e.CVEs.push(cve);
				techMap.set(cve.Technology, e)
			}
		} else {
			techMap.set(cve.Technology, {
				CVEs: [cve]
			});			
		}	
	});
	techMap.forEach((cve, tech) => {
		techList.push(
			{
				Technology: tech, 
				Bucket: cve.CVEs[0].Bucket!,
				PercentNewerVersion: cve.CVEs[0].PercentNewerVersion!,
				CVEs: cve.CVEs
			});
	})	

	// CVE, title, tech, version, first detected, last detected
	return (
		<> 			
		<div className="row row-50">
		<div className="col-12">
			<SectionHeader header={header} link={props.CanonicalURL} anchor='security'/> 
			<div className="table-outer table-rounded table-respoSnsive-lg">
			<table className="table-custom table-custom-striped table-custom-primary  ">
				<thead>
				<tr>
					<th style={{width: '35%'}}>Vulnerable Technology</th>
					<th style={{width: '40%'}}>Security Issues</th>
					<th style={{width: '12%'}}>First Detected</th>
					<th style={{width: '13%'}}>Last Detected</th>
				</tr>
				</thead>
				<tbody>
			{
				techList.map((technology, indexKey) =>
					<CVERow technology={technology} key={indexKey}/>
				)
			}
				</tbody>
			</table>
			</div>
		</div>		
		</div>
		</>
	)
}

interface ChangeRowsProps {
	change: RtMonitoringChange;
}

function ChangeRows({change}: ChangeRowsProps) {
	// reformat to a single list
	let securityA = new Map<string, Event>;
	let securityD = new Map<string, Event>;
	let events: Event[] = [];

	// CVE
	if (change.CVEChanges) {
		change.CVEChanges!.Added!.map((t, i) => {
			if (securityA.has(t.Technology)) {
				let e = securityA.get(t.Technology);
				if (e && e.CVEs) {
					e.CVEs.push(t.CVEId);
					securityA.set(t.Technology, e)
				}
			} else {
				securityA.set(t.Technology, {
					Technology: t.Technology,
					TechnologyURL: t.TechnologyURL,
					TechnologyIcon: t.TechnologyIcon, 
					Version: t.Version!,
					Bucket: t.Bucket!,
					PercentNewerVersion: t.PercentNewerVersion!,
					Event: Events.cveAdded,
					CVEs: [t.CVEId]
				});			
			}
		});		
		change.CVEChanges!.Dropped!.map((t, i) => {
			if (securityD.has(t.Technology)) {
				let e = securityD.get(t.Technology);
				if (e && e.CVEs) {
					e.CVEs.push(t.CVEId);
					securityD.set(t.Technology, e)
				}
			} else {
				securityD.set(t.Technology, {
					Technology: t.Technology,
					TechnologyURL: t.TechnologyURL,
					TechnologyIcon: t.TechnologyIcon, 
					Version: t.Version!,
					Bucket: t.Bucket!,
					PercentNewerVersion: t.PercentNewerVersion!,
					Event: Events.cveDropped,		
					CVEs: [t.CVEId]
				});			
			}
		});
		// --
		securityA.forEach(e=>{
			events.push(e);
		})	
		securityD.forEach(e=>{
			events.push(e);
		})	
	}
	// Technology
	// Order - Upgrade, Added, Dropped	
	if (change.TechnologyChanges) {
		change.TechnologyChanges!.ChangedVersions!.map((t, i) => {
			events.push({
				Technology: t.Technology,
				TechnologyURL: t.TechnologyURL,
				TechnologyIcon: t.TechnologyIcon, 
				Version: t.VersionTo!,
				Bucket: t.Bucket!,
				PercentNewerVersion: t.PercentNewerVersion!,
				VersionFrom: t.VersionFrom,			
				VersionTo: t.VersionTo,			
				Event: Events.techUpgraded
			});		
		});	
		change.TechnologyChanges!.Added!.map((t, i) => {
			events.push({
				Technology: t.Technology,
				TechnologyURL: t.TechnologyURL,
				TechnologyIcon: t.TechnologyIcon, 
				Version: t.Version!,
				Bucket: t.Bucket!,
				PercentNewerVersion: t.PercentNewerVersion!,
				Event: Events.techAdded
			});		
		});
		change.TechnologyChanges!.Dropped!.map((t, i) => {
			events.push({
				Technology: t.Technology,
				TechnologyURL: t.TechnologyURL,
				TechnologyIcon: t.TechnologyIcon, 
				Version: t.Version!,			
				Bucket: t.Bucket!,
				PercentNewerVersion: t.PercentNewerVersion!,
				Event: Events.techDropped
			});			
		});		
	}



	return  (
	<>
	{
		events.map((event, i) => {
			return (
				<EventRow date={change.Date} event={event} key={i}/>
			);
		})	
	}
	</>)
}

interface EventRowProps {
	date: Date;
	event: Event;
}

function EventRow({date, event}: EventRowProps) {
	if (!date) return (<></>);
	if (!event) return (<></>);

	// Date, CVE, title, tech, version
	return (
		<>
		<tr>   		      
			<td>
				{_printShortFullDate(date)}
			</td>     
			<td>
				<EventDescription event={event} />
			</td>    			
			<td>	  
				<Link 
					to={`/technology/${event.TechnologyURL}`}
					className="link-hover" 
					title={event.Technology} 
				>				
					<TechnologySmallIcon 
						technologyIcon={event.TechnologyIcon} 
						technology={event.Technology}
					/>
					{' '}{event.Technology}
				</Link> 
				{' '}                  						
				<VersionRef 
					technology= {{
						TechnologyURL: event.TechnologyURL,
						Technology: event.Technology,
						Version: event.Version
				}}/>					
				{' '}
				<TechnologyVersionWithScore 
						technology={{
							TechnologyURL: event.TechnologyURL,
							Version: event.Version,
							Bucket: event.Bucket,
							PercentNewerVersion: event.PercentNewerVersion
						}}
						tooltip ='1'
					/>                    
			</td>			
		</tr>		
		</>
	)
}
interface CVELinkProps {
	CVEId: string;
	i: number;
}

function CVELink({CVEId, i}: CVELinkProps) {
	// 3 CVE max (dont have space)
	if (i === 3) return (<>, ...</>);
	if (i >= 4) return (<></>);
	return (
		<>
		{!!i && <>{','}</>}
		{' '}
		<Link 
			to={`/cve/${CVEId}`} 
			className="link-hover" 
		>
			{CVEId}
		</Link> 
		</>
	)
}


interface EventDescriptionProps {
	event: Event;
}

function EventDescription({event}: EventDescriptionProps) {
	if (!event) return (<></>);

	switch(event.Event) {
		case Events.techAdded: 
			return (<>
				<i className="fa fa-plus" style={{color: 'green'}}/>&nbsp;Technology Added
			</>); 
		case Events.techDropped: 			
			return (<>
				<i className="fa fa-minus" style={{color: 'red'}}/>&nbsp;Technology Dropped
			</>); 
		case Events.techUpgraded: 			
			return (<>
				<i className="fa fa-refresh" style={{color: 'blue'}}/>&nbsp;
				Version Upgraded from {event.VersionFrom} to {event.VersionTo}
			</>); 
		case Events.cveAdded: 			
			return (<>
				<i className="icon fas fa-exclamation-triangle" style={{color: 'red'}}/>&nbsp;
				Security Issue(s) Discovered:					
					{
						event.CVEs!.map((cve, i) =>
							<CVELink CVEId={cve} key={i} i={i}/>
						)
					}
			</>); 
		case Events.cveDropped: 			
			return (<>
				<i className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}/>&nbsp;
				Security Issues that no longer detectable: 
					{
						event.CVEs!.map((cve, i) =>
							<CVELink CVEId={cve} key={i} i={i}/>
						)
					}
			</>); 
	}
}


interface CVERowProps {
	technology: {Technology: string; Bucket: number; PercentNewerVersion: number; CVEs: RtUICVE[]};
}

function CVERow({technology}: CVERowProps) {
	if (!technology) return (<></>);

	const cve = technology.CVEs[0];

	// tech (with version), Security issues, first detected, last detected
	return (
		<>
		<tr>   		      		
			<td style={{color: 'black'}}>	  
				<Link 
					to={`/technology/${cve.TechnologyURL}`}
					className="link-hover" 
					title={cve.Technology} 
				>				
					<TechnologySmallIcon 
						technologyIcon={cve.TechnologyIcon} 
						technology={cve.Technology}
					/>
					{' '}{cve.Technology}
				</Link>   
				{' '}
				{cve.Version}
				{' '}
				<TechnologyVersionWithScore 
					technology={{
						TechnologyURL: cve.TechnologyURL,
						Version: cve.Version,
						Bucket: cve.Bucket!,
						PercentNewerVersion: cve.PercentNewerVersion!
					}}
					tooltip = '1'
				/>                  						
			</td>	
			<td>
				{
					technology.CVEs.map((cve, i) =>
						<CVELink CVEId={cve.CVEId} key={i} i={i}/>
					)
				}
			</td>     		  
			<td>
				{_printShortFullDate(cve.UsedSince)}
			</td> 			
			<td>
				{_printShortFullDate(cve.LastSeen)}
			</td>       
		</tr>		
		</>
	)
}


interface ScanRowProps {
	scan: Scan;
}

function ScanRow({scan}: ScanRowProps) {
	// Date, Error, Success, Type
	
	return (
		<>
		<tr>   		      
		<td>
				{_printShortFullDate(scan.Date)}
			</td>     
			<td>					
				{scan.Success ? 'Scanned' : "Failed"}                   						
			</td>				
			<td>
				{scan.Error}
			</td>     
		</tr>		
		</>
	)
}
		